import { defineComponent as _defineComponent } from 'vue'
import { MissionStaffingPositionBasicFragmentFragment } from "@/gql"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import DetailsCard from "./DetailsCard.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OpportunitiesOverview',
  props: {
    staffingPosition: null,
    refetchQueries: null
  },
  setup(__props: any) {



return { __sfc: true,DetailsCard }
}

})